import { render, staticRenderFns } from "./ModalErrorAssignWorker.vue?vue&type=template&id=5d6a0dda"
import script from "./ModalErrorAssignWorker.vue?vue&type=script&lang=js"
export * from "./ModalErrorAssignWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports